import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';
import { SidePanelService } from '../services/side-panel.service';
import { SidePanel, SidePanelLayout } from '../models/side-panel.model';
import { HeightWidthService } from '../services/height-width.service';


@Component({
    selector: 'side-panel',
    templateUrl: './side-panel.component.html',
    standalone: false
})
export class SidePanelComponent implements OnInit, OnDestroy {
    public curTab: number = 0;
    public sidePanel: SidePanel = new SidePanel({
        tabs: [],
        sections: [],
        visible: false,
        sidePanelLayout: { },
    });
    public _sidePanelService: Subscription;
    public componentData: any;
    public componentName: string;
    public _hwSubscription: Subscription;
    public top: number = 0;                     //absolute top position
    public bottom: number = 0;                  //absolute bottom position
    public belowMegaMenu: boolean = false;      //display below the main application menu sub-menu's
    public isLeftSide: boolean = false;         //appears on the left side of the app
    public isThin: boolean = false;
    public forceSingleTab: boolean = false;     //show one tab, even if that's all there is
    public showCloseButton: boolean = true;     //show "x" in upper right
    public showTabsForPhoneOnly: boolean = false; //show tab only in at smallest breakpoint
    public hostPadded: boolean = true;          //standard padding around the side panel or none
    extraWide: boolean = false;

    constructor(
        public sidePanelService: SidePanelService,
        public _elementRef: ElementRef,
        public heightWidthService: HeightWidthService,
        public _changeDetectorRef: ChangeDetectorRef,

    ) {
    }

    ngOnInit(): void {
        this._sidePanelService = this.sidePanelService.update().subscribe(newSidePanel => {
            this.sidePanel = newSidePanel.data;
            //set mods to standard right side panel layout
            this.setSidePanelLayoutValues();
            // Flush the [attr.inert]/[attr.tabindex] bindings to the real DOM before focusing -
            // otherwise the aside is still marked inert from the prior (closed) render and the
            // browser silently refuses to focus it, so opening the panel never reaches screen readers.
            // Only on open: newSidePanel/updateSectionData emit while hidden, and forcing a render then
            // builds section components with stale componentData before callers finish updating it.
            if (this.sidePanel.visible) {
                this._changeDetectorRef.detectChanges();
                this._elementRef.nativeElement.firstChild.focus();
            }
            //left side panel can have a single tab
            if (this.sidePanel.tabs.length > 1) {
                //reset tab to first tab
                this.selectTab(0);
            }
        });

        //call to get initial h/w
        this.heightWidthService.sendHW(null);

        //get h/w for initial and all other resizes
        this._hwSubscription = this.heightWidthService.getHW().subscribe(hw => {
            //all of this only applies to constrained side panels
            //  ones that don't cover the header and footer!
            if (this.sidePanel.sidePanelLayout && this.sidePanel.sidePanelLayout.constrainToScrolling) {
                this.top = hw.scrollOffsetTop;
                this.bottom = hw.windowHeight - hw.scrollOffsetBottom;
                //if constrained to scrolling area, display the side panel BELOW the main menu navigation sub-menu's
                this.belowMegaMenu = true;
            }
        });
    }

    ngOnDestroy(): void {
        if (this._sidePanelService)
            this._sidePanelService.unsubscribe();
        if (this._hwSubscription)
            this._hwSubscription.unsubscribe();
    }

    /**
     * layout values that are above and beyond standard right side panel
     * */
    setSidePanelLayoutValues(): void {
        if (this.sidePanel.sidePanelLayout) {
            //left side layout?
            if (this.sidePanel.sidePanelLayout.right != undefined) {
                this.isLeftSide = !this.sidePanel.sidePanelLayout.right;
            }
            //thin?
            if (this.sidePanel.sidePanelLayout.thin != undefined) {
                this.isThin = this.sidePanel.sidePanelLayout.thin;
            }
            //force single tab & show close "x"?
            if (this.sidePanel.sidePanelLayout.forceSingleTab != undefined) {
                this.forceSingleTab = this.sidePanel.sidePanelLayout.forceSingleTab;
                this.showCloseButton = !this.forceSingleTab;
            }
            //show tabs only at PHONE/smallest bp?
            if (this.sidePanel.sidePanelLayout.showTabsPhoneOnly != undefined) {
                this.showTabsForPhoneOnly = this.sidePanel.sidePanelLayout.showTabsPhoneOnly;
            }
            //standard padding around the host?
            if (this.sidePanel.sidePanelLayout.hostPadding != undefined) {
                this.hostPadded = this.sidePanel.sidePanelLayout.hostPadding;
            }

            if (this.sidePanel.sidePanelLayout.extraWide !== undefined) {
                this.extraWide = this.sidePanel.sidePanelLayout.extraWide;
            }
        }
    }

    selectTab(index: number): void {
        
        if (!this.sidePanel.sidePanelLayout || !this.sidePanel.sidePanelLayout.forceSingleTab) {
            //standard tab switching contents
            this.curTab = index;
        } else {
            //only have one tab, act as open/close
            this.sidePanelService.toggleSidePanel(!this.sidePanel.visible);
        }
    }

    /**
     * Close the side panel
     */
    public closePanel(): void {
        this.sidePanelService.toggleSidePanel(false);
    }

    calcClass(length: number): string {
        switch (length) {
            case 1:
                return 'one-tab';
            case 2:
                return 'two-tabs';
            case 3:
                return 'three-tabs';
            default:
                console.log("Missed case in sdeipanel.component > calcClass: " + length);
        }
    }
}